<template>
  <div class="preview-wrapper">
    <!-- Screen-only controls bar -->
    <div
      class="no-print fixed top-0 left-0 w-full bg-white border-b border-gray-200 z-50 px-4 py-3 flex justify-between items-center"
    >
      <Link
        :href="tastingMenuPath"
        class="text-gray-500 hover:text-gray-700 text-sm"
      >
        ← Tillbaka
      </Link>
      <button
        class="bg-emerald-600 text-white px-5 py-2 rounded-lg hover:bg-emerald-700 transition-colors text-sm cursor-pointer"
        @click="exportPdf"
      >
        Exportera PDF
      </button>
    </div>

    <!-- A5 Print-optimized menu -->
    <div class="a5-page">
      <div class="menu-content">
        <!-- Decorative top border -->
        <div class="menu-border-top"></div>

        <!-- Menu header -->
        <div class="menu-header">
          <h1 class="menu-title">{{ menu.title }}</h1>
          <p v-if="menu.description" class="menu-description">
            {{ menu.description }}
          </p>
          <div class="menu-divider">✦</div>
        </div>

        <!-- Courses -->
        <div class="menu-courses">
          <div
            v-for="(course, index) in menu.courses"
            :key="course.id"
            class="menu-course"
          >
            <h2 class="course-name">{{ course.courseName }}</h2>
            <h3 class="course-recipe-title">{{ course.recipe.title }}</h3>
            <p v-if="course.recipe.ingress" class="course-description">
              {{ course.recipe.ingress }}
            </p>
            <div
              v-if="index < menu.courses.length - 1"
              class="course-separator"
            >
              ·
            </div>
          </div>
        </div>

        <!-- Decorative bottom border -->
        <div class="menu-border-bottom"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

defineOptions({
  layout: null,
});

defineProps({
  menu: Object,
  tastingMenuPath: String,
});

function exportPdf() {
  window.print();
}
</script>

<style>
/* A5 dimensions: 148mm × 210mm */
@page {
  size: 148mm 210mm;
  margin: 0;
}

@media print {
  .no-print {
    display: none !important;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    width: 148mm;
    height: 210mm;
  }

  .preview-wrapper {
    margin: 0;
    padding: 0;
  }

  .a5-page {
    width: 148mm;
    height: 210mm;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    page-break-after: always;
  }
}

/* Screen preview: simulate A5 card */
@media screen {
  .preview-wrapper {
    background: #f1f5f9;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 40px;
  }

  .a5-page {
    width: 148mm;
    min-height: 210mm;
    background: #fff;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
}

/* Menu styling - works both print and screen */
.a5-page {
  font-family: "Georgia", "Times New Roman", serif;
  color: #1a1a1a;
  display: flex;
  flex-direction: column;
}

.menu-content {
  padding: 16mm 14mm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
}

.menu-border-top,
.menu-border-bottom {
  width: 60%;
  height: 1px;
  background: #1a1a1a;
  margin: 0 auto;
}

.menu-border-top {
  margin-bottom: 8mm;
}

.menu-border-bottom {
  margin-top: 8mm;
}

.menu-header {
  margin-bottom: 6mm;
}

.menu-title {
  font-size: 20pt;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin: 0 0 3mm 0;
  line-height: 1.2;
}

.menu-description {
  font-size: 9pt;
  font-style: italic;
  color: #555;
  margin: 0 0 4mm 0;
  line-height: 1.4;
}

.menu-divider {
  font-size: 10pt;
  color: #888;
  margin: 2mm 0;
  letter-spacing: 0.3em;
}

.menu-courses {
  width: 100%;
}

.menu-course {
  margin-bottom: 4mm;
}

.course-name {
  font-size: 8pt;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #666;
  margin: 0 0 1mm 0;
}

.course-recipe-title {
  font-size: 13pt;
  font-weight: 600;
  margin: 0 0 1mm 0;
  line-height: 1.3;
}

.course-description {
  font-size: 8.5pt;
  color: #555;
  font-style: italic;
  margin: 0;
  line-height: 1.4;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.course-separator {
  font-size: 14pt;
  color: #bbb;
  margin: 3mm 0;
  letter-spacing: 0.5em;
}
</style>
